(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.ComplianceRuleEnums', ComplianceRuleEnums);
	ComplianceRuleEnums.$inject = ['mx.utils.MxEnum'];

	function ComplianceRuleEnums(MxEnum) {
		var ComplianceRuleTriggerTypes = new MxEnum({
			CreateObject: 1,
			DeleteObject: 2,
			Action: 3,
			ChangeObject: 5,
			External: 6,
		});

		var ComplianceRuleConditionStart = new MxEnum({
			After: 0,
			Before: 1,
		});

		return {
			ComplianceRuleTriggerTypes: ComplianceRuleTriggerTypes,
			ComplianceRuleConditionStart: ComplianceRuleConditionStart,
		};
	}
})();
